import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import { useLocation } from "react-router-dom";
import { AlertType } from "../components/common/ui/alert/Alert";

export interface AlertContextType {
  alert: AlertType | undefined;
  setAlert: (alert: AlertType | undefined) => void;
  clearAlert: () => void;
}

const AlertContext = createContext<AlertContextType | null>(null);

interface AlertProviderProps {
  children: React.ReactNode;
}

export const AlertProvider: React.FC<AlertProviderProps> = ({ children }) => {
  const [alert, setAlertState] = useState<AlertType | undefined>();
  const location = useLocation();

  // Clear alert when route changes
  useEffect(() => {
    setAlertState(undefined);
  }, [location.pathname]);

  const setAlert = useCallback((newAlert: AlertType | undefined) => {
    setAlertState(newAlert);
  }, []);

  const clearAlert = useCallback(() => {
    setAlertState(undefined);
  }, []);

  return (
    <AlertContext.Provider value={{ alert, setAlert, clearAlert }}>
      {children}
    </AlertContext.Provider>
  );
};

export const useAlertContext = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error("useAlertContext must be used within AlertProvider");
  }
  return context;
};
